import React from "react";
import { Link } from "react-router-dom";

const Ourcommitment = () => {
  const features = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="white"/>
        </svg>
      ),
      iconBg: "#41A89B",
      title: "Match & Connect",
      description:
        "Connect with families who truly understand your journey. Our easy-to-use filters help you search by age, gender, interests, and unique needs—empowering you to build meaningful connections that matter.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="white"/>
        </svg>
      ),
      iconBg: "#F5A623",
      title: "Support",
      description:
        "Social Spectrum is not just a platform, it's a supportive community. We provide resources, guidelines, and a network of parents who understand the journey you're on.",
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" fill="white"/>
        </svg>
      ),
      iconBg: "#E84E3A",
      title: "Empowerment",
      description:
        "Our goal is to empower parents to actively contribute to their child's social development by facilitating connections that go beyond the virtual world.",
    },
  ];

  return (
    <div className="w-full bg-white">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16 py-12 md:py-16 flex flex-col items-center">
        {/* Section Header */}
        <div className="flex flex-col items-center gap-3 mb-12 text-center">
          <p className="text-[13px] font-[700] font-nunito tracking-[0.15em] uppercase" style={{ color: "#1167D0" }}>
            OUR FEATURES
          </p>
          <h2 className="text-[28px] md:text-[40px] font-[800] text-[#0D121F] font-quicksand leading-tight max-w-[600px]">
            Empowering Caregivers, One Connection at a Time.
          </h2>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 w-full gap-6">
          {features.map((feature, i) => (
            <div
              key={i}
              className="flex flex-col items-start p-8 rounded-[20px] bg-white"
              style={{
                border: "1.5px solid #E8ECF4",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
                transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
                cursor: "default",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = "0px 16px 40px rgba(17, 103, 208, 0.15)";
                e.currentTarget.style.borderColor = "#C8DCF5";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "translateY(0px)";
                e.currentTarget.style.boxShadow = "0px 4px 20px rgba(0, 0, 0, 0.05)";
                e.currentTarget.style.borderColor = "#E8ECF4";
              }}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 rounded-[14px] flex items-center justify-center mb-6"
                style={{
                  background: feature.iconBg,
                  boxShadow: `0 4px 12px ${feature.iconBg}55`,
                }}
              >
                {feature.icon}
              </div>

              <h3 className="text-[19px] font-[700] text-[#0D121F] mb-3 font-quicksand">
                {feature.title}
              </h3>
              <p className="text-[15px] text-[#6B7280] leading-[1.7] font-nunito">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12">
          <Link
            to="/ourapp"
            className="flex items-center gap-2 py-[13px] px-8 text-white text-[15px] font-[700] rounded-[32px] font-nunito"
            style={{
              background: "#1167D0",
              boxShadow: "0 4px 16px rgba(17, 103, 208, 0.35)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "scale(1.06)";
              e.currentTarget.style.boxShadow = "0 8px 24px rgba(17, 103, 208, 0.45)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(17, 103, 208, 0.35)";
            }}
          >
            Know More →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Ourcommitment;
